import { render, staticRenderFns } from "./bindPhoneSuccess.vue?vue&type=template&id=08f499dc&scoped=true"
import script from "./bindPhoneSuccess.vue?vue&type=script&lang=js"
export * from "./bindPhoneSuccess.vue?vue&type=script&lang=js"
import style0 from "./bindPhoneSuccess.vue?vue&type=style&index=0&id=08f499dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f499dc",
  null
  
)

export default component.exports